
import Chip from '@mui/material/Chip';

import { useEnumApi } from 'contexts/EnumApiContext';
import { ROLE } from 'data/data';
import MainCard from 'components/MainCard';
import EquipmentAlertAndInspectionTable from 'components/table/EquipmentAlertAndInspectionTable';
import AttentionObservationRequestLayer from 'components/layer/AttentionObservationRequestLayer';
import ConstantInspectionFollowActionTypeRequestLayer from 'components/layer/ConstantInspectionFollowActionTypeRequestLayer';
import MaintenanceRequestLayer from 'components/layer/MaintenanceRequestLayer';
import { useTranslation } from 'react-i18next';

const EquipmentAlertInfoCard = ({equipmentAlert , maintenanceTask, setIsLoading : setParentIsLoading}) => {
    const { t } = useTranslation();
    const { role } = useEnumApi();
    if (equipmentAlert) {
      return (
          <>
            <MainCard className="center_table" content={false}>
              <div className='history_tit' style={{display: "flex", alignItems: "center", backgroundColor:"#353535"}}>
                <div style={{marginBottom:"7px"}}>
                  <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/subway1.png`} alt='' /></span>&nbsp;
                  <Chip label={t('message.common.chip.alert.site.inspection.detail')} color="success"/>
                </div>
              </div>

              <EquipmentAlertAndInspectionTable equipmentAlert={equipmentAlert} maintenanceTask={maintenanceTask} setIsLoading={setParentIsLoading} />
            </MainCard>

            { role !== ROLE.MO.code &&
            <div className="btn_right">
              {equipmentAlert.fllwActionType && equipmentAlert.fllwActionType === 'O1_WAIT' && <ConstantInspectionFollowActionTypeRequestLayer alertId={equipmentAlert.id} setIsLoading={setParentIsLoading} />}
              {equipmentAlert.fllwActionType && equipmentAlert.fllwActionType === 'O2_OBSERVE' && <AttentionObservationRequestLayer alertId={equipmentAlert.id} setIsLoading={setParentIsLoading}/>}
              {equipmentAlert.fllwActionType && equipmentAlert.fllwActionType === 'O3_MNT' && equipmentAlert.mntTask === undefined && <MaintenanceRequestLayer alertId={equipmentAlert.id} setIsLoading={setParentIsLoading}/>}
              {/* {equipmentAlert.fllwActionType && equipmentAlert.fllwActionType === 'O3_MNT' && maintenanceTask && maintenanceTask.status !== 'O3_C' && maintenanceTask.status !== 'O4_V' && <MaintenanceRequestLayer alertId={equipmentAlert.id} setIsLoading={setIsLoading} type="modify"/>} */}
            </div>
            }
          </>
      )
    }
}

export default EquipmentAlertInfoCard;